export function SecretariaatPage() {
  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Secretariaat klaar-check</h1>
          <p>7 dossiers wachten op bevestiging van administratieve gereedheid</p>
        </div>
      </div>
      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Ref.</th>
              <th>Onderzoeker / Project</th>
              <th>Ingediend</th>
              <th>Open issues</th>
              <th>Onderzoekersactie</th>
              <th>Deadline Bureau</th>
              <th>Actie secretariaat</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="ua-muted-xs">EA-2026-043</td>
              <td>
                <div className="ua-bold-sm">Lien Maes</div>
                <div className="ua-muted-xs">Kwalitatief onderzoek in de jeugdzorg</div>
              </td>
              <td>24 jun</td>
              <td>
                <span className="badge badge--success">Geen open</span>
              </td>
              <td>
                <span className="badge badge--info">Herzien</span>
              </td>
              <td className="ua-bold-sm">2 jul</td>
              <td className="ua-nowrap">
                <button className="btn btn--primary px-[10px] py-1 text-[12px]">Bevestigen</button>
                <button className="btn btn--ghost ml-1 px-[10px] py-1 text-[12px]">
                  Terugsturen
                </button>
              </td>
            </tr>
            <tr>
              <td className="ua-muted-xs">EA-2026-036</td>
              <td>
                <div className="ua-bold-sm">Pieter Claes</div>
                <div className="ua-muted-xs">Mixed methods over armoede en welzijn</div>
              </td>
              <td>16 jun</td>
              <td>
                <span className="badge badge--success">Geen open</span>
              </td>
              <td>
                <span className="badge badge--success">Herzien</span>
              </td>
              <td className="ua-bold-sm">2 jul</td>
              <td className="ua-nowrap">
                <button className="btn btn--primary px-[10px] py-1 text-[12px]">Bevestigen</button>
                <button className="btn btn--ghost ml-1 px-[10px] py-1 text-[12px]">
                  Terugsturen
                </button>
              </td>
            </tr>
            <tr>
              <td className="ua-muted-xs">EA-2026-033</td>
              <td>
                <div className="ua-bold-sm">Sara Bogaert</div>
                <div className="ua-muted-xs">Etnografie bij informele zorgverleners</div>
              </td>
              <td>10 jun</td>
              <td>
                <span className="badge badge--warning">1 open (midden)</span>
              </td>
              <td>
                <span className="badge badge--warning">Doorgegaan met uitleg</span>
              </td>
              <td className="ua-bold-sm">2 jul</td>
              <td className="ua-nowrap">
                <button className="btn btn--primary px-[10px] py-1 text-[12px]">Bevestigen</button>
                <button className="btn btn--ghost ml-1 px-[10px] py-1 text-[12px]">
                  Terugsturen
                </button>
                <button className="btn btn--ghost ml-1 px-[10px] py-1 text-[12px]">Escaleer</button>
              </td>
            </tr>
            <tr>
              <td className="ua-muted-xs">EA-2026-031</td>
              <td>
                <div className="ua-bold-sm">Kevin De Smedt</div>
                <div className="ua-muted-xs">Survey over online pesten bij adolescenten</div>
              </td>
              <td>8 jun</td>
              <td>
                <span className="badge badge--warning">2 open (1 hoog)</span>
              </td>
              <td>
                <span className="badge badge--danger">Menselijke review aangevraagd</span>
              </td>
              <td className="ua-bold-red">2 jul ⚠</td>
              <td className="ua-nowrap">
                <button className="btn btn--ghost px-[10px] py-1 text-[12px]">Terugsturen</button>
                <button className="btn btn--secondary ml-1 px-[10px] py-1 text-[12px]">
                  Escaleer naar voorzitter
                </button>
              </td>
            </tr>
            <tr>
              <td className="ua-muted-xs">EA-2026-029</td>
              <td>
                <div className="ua-bold-sm">Elke Vandenberghe</div>
                <div className="ua-muted-xs">Observatie van straatwerk bij jongeren</div>
              </td>
              <td>5 jun</td>
              <td>
                <span className="badge badge--success">Geen open</span>
              </td>
              <td>
                <span className="badge badge--info">Herzien</span>
              </td>
              <td className="ua-bold-sm">2 jul</td>
              <td className="ua-nowrap">
                <button className="btn btn--primary px-[10px] py-1 text-[12px]">Bevestigen</button>
                <button className="btn btn--ghost ml-1 px-[10px] py-1 text-[12px]">
                  Terugsturen
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="ua-pager-info">+ 2 overige dossiers in klaar-check wachtrij</div>
      </div>
    </section>
  );
}
